// extracted by mini-css-extract-plugin
export var active = "_qg-1";
export var circle = "_qg-0";
export var completed = "_qg-2";
export var connector = "_qg-4";
export var connectorCompleted = "_qg-7";
export var connectorSpacer = "_qg-5";
export var iconStrokeOverride = "_qg-8";
export var labelContainer = "_qg-6";
export var pending = "_qg-3";